import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AccessService} from './access';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DataService {

    private http = inject(HttpClient);
    private accessService = inject(AccessService);

    request(action: string, dataObject: object|null = null): Observable<any> {
        return this.http
            .post(environment.apiUrl, {
                action,
                data: dataObject,
            }, {
                headers: {"Authorization": this.accessService.token}
            });
    }

}




